import { useState, useCallback } from "react";
import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import { BlockEditModal } from "../BlockEditModal";
import { sanitizeToHtml } from "@/components/preview/BlockRenderer";
import styles from "../blocks/blocks.module.scss";

export function AbstractNodeView({ node, updateAttributes, selected, deleteNode }: NodeViewProps) {
  const title = (node.attrs.title as string) || "Abstract";
  const text = (node.attrs.text as string) || "";

  const [isOpen, setIsOpen] = useState(false);
  const [draftText, setDraftText] = useState(text);

  const handleOpen = useCallback(() => {
    setDraftText(text);
    setIsOpen(true);
  }, [text]);

  const handleSave = useCallback(() => {
    updateAttributes({ text: draftText });
    setIsOpen(false);
  }, [draftText, updateAttributes]);

  return (
    <NodeViewWrapper data-type="abstract-block" data-block-id={node.attrs.blockId} className={selected ? "ProseMirror-selectednode" : ""}>
      <div className={styles.abstractBlock} onClick={handleOpen} style={{ cursor: "pointer" }}>
        <h2 className={styles.abstractTitle}>{title}</h2>
        {text ? (
          <div
            className={styles.abstractContent}
            dangerouslySetInnerHTML={{ __html: sanitizeToHtml(text) }}
          />
        ) : (
          <div className={styles.abstractContent}>
            <span style={{ color: "var(--lilia-text-muted, #999)" }}>Click to add abstract...</span>
          </div>
        )}
      </div>

      <BlockEditModal
        sourceNode={node}
        title="Edit Abstract"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onSave={handleSave}
        onDelete={() => { setIsOpen(false); deleteNode(); }}
        width={640}
      >
        <div>
          <label style={{ display: "block", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Content</label>
          <textarea
            value={draftText}
            onChange={(e) => setDraftText(e.target.value)}
            placeholder="Enter the abstract of your document..."
            rows={8}
            autoFocus
            style={{
              width: "100%", padding: "12px", fontSize: 13,
              border: "1px solid var(--lilia-border, #ddd)", borderRadius: 4,
              resize: "vertical", lineHeight: 1.6,
            }}
          />
        </div>
      </BlockEditModal>
    </NodeViewWrapper>
  );
}
